import {RouteRecordRaw} from "vue-router";

const Message: RouteRecordRaw[] = [{
    path: "message/edit/:uuid",
    name: "H5MessageEdit",
    component: () => import("@/page/h5/message/edit/index.vue"),
}]

export default Message
